import { Analytics } from '@watershed/analytics/analyticsUtils';
import { CustomSpanAttributes } from '@watershed/shared-universal/constants/otelCustomAttributes';
import {
  Honeycomb,
  HoneycombEvent,
} from '@watershed/shared-universal/honeycomb';

const frontendHoneycomb = new Honeycomb({
  enabled: process.env.NEXT_PUBLIC_HONEYCOMB_ENABLED !== 'false',
  key: process.env.NEXT_PUBLIC_HONEYCOMB_KEY || '',
  dataset: process.env.NEXT_PUBLIC_ENVIRONMENT || '',
  serviceName: `${process.env.NEXT_PUBLIC_APPLICATION}-frontend`.toLowerCase(),
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT || '',
  developerName: process.env.NEXT_PUBLIC_WS_USER,
  universalAttributes: {},
  beforeSend: honeycombBeforeSend,
});

export default frontendHoneycomb;

function honeycombBeforeSend(event: HoneycombEvent): void {
  event.addField(CustomSpanAttributes.BROWSER_PATH, window.location.pathname);
  event.addField(CustomSpanAttributes.BROWSER_URL, window.location.href);

  if (Analytics.userProperties) {
    event.addField(
      CustomSpanAttributes.USER_ID,
      Analytics.userProperties['userId']
    );
    event.addField(
      CustomSpanAttributes.USER_IS_CUSTOMER,
      Analytics.userProperties['isCustomer']
    );
    event.addField(
      CustomSpanAttributes.USER_EMAIL,
      Analytics.userProperties['userEmail']
    );
    event.addField(
      CustomSpanAttributes.ORG_ID,
      Analytics.userProperties['orgId']
    );
    event.addField(
      CustomSpanAttributes.ORG_NAME,
      Analytics.userProperties['orgName']
    );
    event.addField(
      CustomSpanAttributes.LOGIN_AS_USER_ID,
      Analytics.userProperties['loginAsUserId']
    );
    event.addField(
      CustomSpanAttributes.LOGIN_AS_USER_NAME,
      Analytics.userProperties['loginAsUserName']
    );
    event.addField(
      CustomSpanAttributes.FULLSTORY_SESSION_URL,
      Analytics.syncGetFullStorySessionURL()
    );
    event.addField(
      CustomSpanAttributes.FULLSTORY_SESSION_ID,
      Analytics.syncGetFullStorySessionId()
    );
  }
}
